import { createAction } from '@reduxjs/toolkit';

export const apiKeysSettingsActions = {
  navigateTo: createAction<{ navigateTo: string }>('ApiKeysSettingsActions/navigateTo'),
};
